<template>
    <div :class="classes">
        <div v-for="(step, i) in items" class="step" :class="{ active: i < currentStep }">
            <div v-if="step.title" class="step-title">{{ i + 1 }}. {{ step.title }}</div>
            <div class="step-indicator"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: { type: String, default: 'default' },
        currentStep: { type: Number, default: 1 },
        steps: { type: [Array, Number], required: true },
    },

    data: () => {
        return {
            items: [],
        };
    },

    computed: {
        classes() {
            return {
                configurationStepper: true,
                'configurationStepper--simple': this.type === 'simple',
            };
        },
    },

    methods: {
        init() {
            if (typeof this.steps === 'number') {
                this.items = Array(this.steps)
                    .fill()
                    .map(() => ({}));
            } else {
                this.items = this.steps;
            }

            for (let i = 0; i < this.currentStep; i++) {
                this.items[i].active = true;
            }
        },
    },

    mounted() {
        this.init();
    },
};
</script>
